import React, { useState, Fragment } from "react";
import {
  GET_LIST,
  SimpleForm,
  Toolbar,
  SaveButton,
  SelectInput,
} from "react-admin";
import { Card} from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from "moment-timezone";
import {
  map,
  curry,
  range,
  isNil,
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import ReactExport from "react-export-excel";
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
import ReactExport from "react-data-export";
import CustomDatePickerYM from "./CustomDatePickerYM";
import { API_ROOT } from "../api-config";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "50%",
  },
  flex: { display: "flex", flexDirection:'column' },
  emailsCard: {padding: '10px 20px', backgroundColor: 'rgb(254 151 0 / 12%)', borderRadius: '4px',
              boxShadow: 'rgb(255 152 0 / 2%) 0px 30px 60px -12px inset, rgb(253 229 193) 0px 18px 36px -18px inset', 
              display: "flex", flexDirection: "row", margin: "20px", width: '50%', flexWrap: 'wrap'}
};

let dataSetAll = [];
let dataSetRentals = [];
let yearsArray = [];

class reportToursCount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      locationsArray: null,
      locationSearch: null,
      yearsEnd: moment().startOf("year").format("YYYYMMDD"),
      optDateBegin: null,
      optDateEnd: null,
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment().startOf("month").format("YYYYMMDD"),
      emailsGroup: null,
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const startDate = moment().format("YYYYMMDD");
    const endDate = moment().format("YYYYMMDD");
    await this.updateState(startDate, endDate, null, null, null);
  }

  updateState = async (startDate, endDate, optDateBegin, optDateEnd) => {
    this.setState({
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate).format("YYYYMMDD"),
      optDateBegin,
      optDateEnd,
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChangeOptE = (eventDate) => {
    this.setState({ optDateEnd: eventDate });
  };

  handleChangeOptB = (eventDate) => {
    this.setState({ optDateBegin: eventDate });
  };

  handleDateTimeChange = (event, fieldName) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetRentals = [];
    dataSetAll = [];
    if (
      this.state.optDateBegin !== null &&
      this.state.optDateEnd !== null &&
      this.state.optDateBegin !== "" &&
      this.state.optDateEnd !== ""
    ) {
      this.setState({ exportData: [], loading: true, showTables: true });
      this.getReports(
        this.state.optDateBegin,
        this.state.optDateEnd
      );
    }
  };

  async getReports(startDate, endDate) {

    const eventDateStart = moment(this.state.optDateBegin._d).format("YYYY");
    const eventDateEnd = moment(this.state.optDateEnd._d).format("YYYY");  
    const dataProvider = await dataProviderFactory("rest");
    const reportTours = dataProvider(GET_LIST, "reports/reportToursTotal", {
      filter: {
        dateStart: eventDateStart,
        dateEnd: eventDateEnd,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    reportTours
      .then(async (result) => {
        this.state.loading = false;
        dataSetAll = result.data;
        // Obtenemos una lista de todos los años disponibles
        yearsArray = Array.from(
          new Set(dataSetRentals.map((item) => item.years))
        );

        const dataSet = [
          {
            columns: [
              {
                title: "Client Name ",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Email",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
            ],
            data: dataSetRentals.map((data) => [
              {
                value: data.client_name != null ? data.client_name : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.email != null ? data.email : "",
                style: { font: { sz: "12" } },
              },
            ]),
          },
        ];

        this.setState({ loading: false, DataSet: dataSet });

        return result.data;
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }


  async getReportsDownload(startDate, endDate) {
    let data = {
      startDate: startDate,
      endDate: endDate,
    };

    const response = await fetch(`${API_ROOT}/reports/download`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
      body: JSON.stringify(data),
    });

    let commits = await response.json(); // read response body and parse as JSON

    let a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
    a.download = `Metrics.xlsx`;
    a.click();
    a.remove();
  }

  render() {
    const {
      isLoading,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }
    const toursByYear = {};
    dataSetAll.forEach(item => {
      if (!toursByYear[item.year]) {
        toursByYear[item.year] = {year: null, toursG: null, toursSG: null}
      }

      if (item.count > 0 ){
        if (item.self_guided == 1){
          toursByYear[item.year].toursSG ++
        } else {
          toursByYear[item.year].toursG ++
        }
      }
      // toursByYear[item.years].years = item.years;
      // toursByYear[item.years].toursG = item.toursG;
      // toursByYear[item.years].toursSG = item.toursSG;
      // toursByYear[item.years].totalTours = item.totalTours;
    });

    const PostCreateToolbar = (props) => (
      <Toolbar {...props} style={{ backgroundColor: "transparent" }}>
        <SaveButton
          label="Generate"
          type="submit"
          onClick={this.handleChange}
        />
      </Toolbar>
    );

    return (
      <Card>
        <h3 style={{ display: "flex", margin: "20px" }}>Tours Report </h3>
        <div style={{ display: "flex", flexDirection: "row", margin: "20px" }}>
          <div>
            <SimpleForm toolbar={false}>
              <CustomDatePickerYM
                onChange={e => this.handleChangeOptB(e)}
                selectedDate={optDateBegin}
                label="Start Year"
                margin="normal"
                minDate={'2020-01-01'}
                maxDate={Date.now()}
                format={'YYYY'}
                view={'year'}
              />            
            </SimpleForm>
            <SimpleForm toolbar={false}>
              <CustomDatePickerYM
                onChange={e => this.handleChangeOptE(e)}
                selectedDate={optDateEnd}
                label="End Year"
                margin="normal"
                minDate={'2020-01-01'}
                maxDate={Date.now()}
                format={'YYYY'}
                view={'year'}
              />               
            </SimpleForm>
             
          </div>
        </div>
        <PostCreateToolbar />

        {this.state.showTables ? (
          <div style={styles.flex}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3} style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>
                    <h3> Tour Count </h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>YEAR</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>NUM TOURS G</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>NUM TOURS SG</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>TOTAL TOURS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(toursByYear).map((year) => (
                  <TableRow key={year}>
                    <TableCell style={styles.centerAlignedCell}>
                      {year}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {toursByYear[year].toursG} 
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {toursByYear[year].toursSG} 
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {toursByYear[year].toursSG + toursByYear[year].toursG} 
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>          
          </div> 
         ) : null}
        <div style={{ marginBottom: "10px" }}></div>
      </Card>
    );
  }
}

export default reportToursCount;



// WEBPACK FOOTER //
// ./src/components/reportToursCount.js